import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import ArrowsDownToPeopleIcon from '@eversports/design-tokens/assets/icons/regular/arrows-down-to-people.svg'
import NoSsr from '@eversports/klimt-design-components/NoSsr'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { useGenerateVenueReferralCodeMutation, useVenueReferAFriendButtonVenueContextQuery } from '../../../../graphql'
import { Localized } from '../../../../localization/react'
import FavoriteAndShareButtonsBox from '../FavoriteAndShareButtons/components/FavoriteAndShareButtonsBox'

import { ErrorSnackbarPortal } from './ErrorSnackbarPortal'
import { VenueReferAFriendOverlay } from './VenueReferAFriendOverlay'

export function VenueReferAFriendButton() {
  const { amplitude } = useAmplitude()
  const { venueSlug } = useParams<{ venueSlug: string }>()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [hasError, setHasError] = useState(false)
  const { data } = useVenueReferAFriendButtonVenueContextQuery({
    variables: { slug: venueSlug },
  })
  const [generateReferralCode, { data: generatedData }] = useGenerateVenueReferralCodeMutation()

  const venue = data?.venueContext.venue
  const referral = venue?.company.referral ?? null
  const generatedReferral = generatedData?.generateReferralCode ?? null

  const referralCode = generatedReferral?.code ?? referral?.code ?? null
  const rewardDescription = generatedReferral?.rewardDescription ?? referral?.rewardDescription ?? null

  const toggleDialog = () => {
    setIsDialogOpen((prev) => !prev)
  }

  const handleClick = async () => {
    if (!venue) return

    if (amplitude) {
      amplitude.logEvent('Clicked Venue Profile Refer A Friend Button', {
        venue: {
          name: venue.name,
          slug: venue.slug,
        },
      })
    }

    if (!referralCode) {
      const result = await generateReferralCode({ variables: { companyId: venue.company.id } })
      if (!result.data?.generateReferralCode) {
        setHasError(true)
        return
      }
    }

    if (!referralCode && !rewardDescription) return

    setIsDialogOpen(true)
  }

  return (
    <>
      <FavoriteAndShareButtonsBox onClick={() => void handleClick()}>
        <Stack direction="row" alignItems="center" gap={3}>
          <Text variant="xsmall" sx={{ color: 'black', fontWeight: 'bold', display: { xs: 'none', sm: 'initial' } }}>
            <Localized id="refer-a-friend-venue-profile" />
          </Text>
          <Icon src={ArrowsDownToPeopleIcon} size="small" color="midnight" />
        </Stack>
      </FavoriteAndShareButtonsBox>
      {referralCode && rewardDescription && (
        <VenueReferAFriendOverlay
          isOpen={isDialogOpen}
          toggleDialog={toggleDialog}
          venueName={venue?.name ?? ''}
          referralCode={referralCode}
          rewardDescription={rewardDescription}
        />
      )}
      <NoSsr>
        <ErrorSnackbarPortal
          isOpen={hasError}
          errorMessage="Something went wrong. Please try again."
          onClose={() => setHasError(false)}
        />
      </NoSsr>
    </>
  )
}
